module.exports = __webpack_public_path__ + "static/thotcon-openbci-setup-bccbfa7b79833da2bb9f10734bfe34c6.gif";